//for implementation you can check dependents module
import React from 'react';
import {
  makeStyles, Box, InputLabel, TextField,
} from '@material-ui/core';
import useTranslateText from '../use_translate_text';

const useStyles = makeStyles((theme) => ({
  input: {
    height: 40,
    [theme.breakpoints.up('300')]: {
      width: 130,
    },
    [theme.breakpoints.up('576')]: {
      width: 200,
    },
    [theme.breakpoints.up('768')]: {
      width: 130,
    },
    [theme.breakpoints.up('1024')]: {
      width: 160,
    },
    color: '#76787A',
    fontSize: '14px',
  },
  input_priority: {
    width: 80,
  },
  labelAsterisk: {
    color: 'red',
  },
}));

const SSNFieldComponent = (props) => {
  const classes = useStyles(),
        { value1, value2, value3, register1, register2, register3, lable, name1, name2, name3, autoComplete, error, errors, helperText,
          onChange1, onChange2, onChange3, typeField, required } = props,
        { translateText } = useTranslateText();

  return (
    <Box className="dependents-main__formDiv__input_container w-50">
      <InputLabel required={required} component="legend"
        className={`${classes.label_form} labels mt-3`}>
        {`${translateText(lable)}:`}
      </InputLabel>
      <Box className="d-flex">
        <Box>
          <TextField {...
            {
              InputProps: {
                className: `${classes.input} ${classes.input_priority}`,
              },
              placeholder: '-',
              name: name1,
              id: 'outlined-password-input',
              type: typeField,
              size: 'small',
              value: value1 ? value1.replace(/[^\d]/g, '') : '',
              autoComplete,
              variant: 'outlined',
              inputRef: register1,
              inputProps: { maxLength: 3 },
              onChange: onChange1,
              error,
            }
          } />
        </Box>
        <Box className="ml-3">
          <TextField {...
            {
              InputProps: {
                className: `${classes.input} ${classes.input_priority}`,
              },
              placeholder: '-',
              name: name2,
              id: 'outlined-password-input',
              type: typeField,
              size: 'small',
              value: value2 ? value2.replace(/[^\d]/g, '') : '',
              autoComplete,
              variant: 'outlined',
              inputRef: register2,
              inputProps: { maxLength: 2 },
              onChange: onChange2,
              error,
            }
          } />
        </Box>
        <Box className="ml-3">
          <TextField {...
            {
              InputProps: {
                className: `${classes.input} ${classes.input_priority}`,
              },
              placeholder: '-',
              name: name3,
              id: 'outlined-password-input',
              type: 'text',
              size: 'small',
              value: value3 ? value3.replace(/[^\d]/g, '') : '',
              autoComplete,
              variant: 'outlined',
              inputRef: register3,
              inputProps: { maxLength: 4 },
              onChange: onChange3,
              error,
            }
          } />
        </Box>
      </Box>
      {errors && helperText}
    </Box>
  );
};

export default SSNFieldComponent;